import { render } from "./AccountsTable.vue?vue&type=template&id=4dd2c55e"
import script from "./AccountsTable.vue?vue&type=script&lang=js"
export * from "./AccountsTable.vue?vue&type=script&lang=js"

import "./AccountsTable.vue?vue&type=style&index=0&id=4dd2c55e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__